import { useState } from 'react'

import { VariantProps } from '@stitches/react'

import {
  StyledButtonGroup,
  StyledButtonGroupButton
} from './button-group.styles'

type ButtonGroupButton = {
  title: string
  action: () => void
}

export const ButtonGroup = ({
  buttons,
  defaultActive,
  size = 'small'
}: {
  buttons: ButtonGroupButton[]
  defaultActive?: string
  size?: VariantProps<typeof StyledButtonGroup>['size']
}) => {
  const [activeButton, setActiveButton] = useState<string>(
    defaultActive || buttons[0].title
  )
  return (
    <StyledButtonGroup size={size}>
      {buttons.map(button => (
        <StyledButtonGroupButton
          key={button.title}
          isActive={activeButton === button.title}
          onClick={() => {
            setActiveButton(button.title)
            button.action()
          }}
        >
          {button.title}
        </StyledButtonGroupButton>
      ))}
    </StyledButtonGroup>
  )
}
